import "./WidgetItemTextHtml.css"
import { useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { useEffect, useState } from "react";
import HtmlParse from 'html-react-parser';
import { Form, Modal } from 'react-bootstrap';
import SrvButton from '../../global/SrvButton';
import SrvButtonLink from '../../global/SrvButtonLink';
import { useSelector } from "react-redux";
import BlockName from "./BlockName";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import ErrorAdd from "../../../util/ErrorAdd";

function WidgetItemTextHtml({ idTask, idWidget, number, idObject, editMode, onlyRead, name, nameChange, showTracker, showTrackerChange, widgetUpdateHandler, added }) {
    //added - true при событии добавления виджета
    const stateData = useSelector((state) => state.widgetData);//Данные для виджета

    const [edit, setEdit] = useState(false);
    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(null);

    const editorRef = useRef(null);

    useEffect(() => {
        setLoading(false);
        setLog(null);
    }, []);

    useEffect(() => {
        if (added !== null & added !== undefined) {
            //Ограничение на добавление виджета определенного номера. Иначе открываются сразу все виджеты
            if (added.idWidget === idWidget & added.number === number) {
                setEdit(true);
            }
        }
    }, [added]);

    function Update() {
        setLoading(true);
        if (idObject === 1) {
            axios.post('/api_tracker/task/widgetHtmlSet', { ID_Task: idTask, Widget_Number: number, Html: editorRef.current.getContent() })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setEdit(false);
                    }
                    else {
                        setLog(res.data.Error);
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
        if (idObject === 2) {
            axios.post('/api_tracker/taskR/widgetHtmlSet', { ID_TaskR: idTask, Widget_Number: number, Html: editorRef.current.getContent() })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setEdit(false);
                    }
                    else {
                        setLog(res.data.Error);
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
        if (idObject === 3) {
            axios.post('/api_tracker/board/taskWidgetHtmlSet', { ID_Board_Task: idTask, Widget_Number: number, Html: editorRef.current.getContent() })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setEdit(false);
                    }
                    else {
                        setLog(res.data.Error);
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
        //Обновляем настройки виджета
        widgetUpdateHandler();
    }

    return (
        <div>
            {stateData.dataTextHtml.filter(a => a.Widget_Number === number).length === 0 && (
                <div className="text-center">
                    <SrvButton typeBtn='add' textBtn="Добавить Html" size='lg' onClick={() => setEdit(true)} />
                </div>
            )}
            {edit === false ?
                (
                    <div className=''>
                        {stateData.dataTextHtml.filter(a => a.Widget_Number === number).length > 0 &&
                            <div className='card_widget_body' style={{ minHeight: "50px" }}>
                                {editMode === false && (
                                    onlyRead !== true && (
                                        <div className="card_widget_btn_edit">
                                            <SrvButtonLink typeBtn="edit" textBtn="" onClick={() => setEdit(true)} />
                                        </div>
                                    )
                                )}
                                {HtmlParse(stateData.dataTextHtml.filter(a => a.Widget_Number === number)[0].Html)}
                            </div>
                        }
                    </div>
                )
                :
                (
                    <Modal show={edit} onHide={() => setEdit(false)} size='lg'>
                        <Modal.Body>
                            <div className="modal_close" onClick={() => setEdit(false)}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                            <div className="modal_title text-center">Html текст</div>
                            <BlockName name={name} setName={nameChange} updateHandler={widgetUpdateHandler} />
                            <Editor
                                tinymceScriptSrc={process.env.PUBLIC_URL + '/scripts/tinymce/tinymce.min.js'}
                                onInit={(evt, editor) => editorRef.current = editor}

                                initialValue={stateData.dataTextHtml.filter(a => a.Widget_Number === number).length > 0 ? stateData.dataTextHtml.filter(a => a.Widget_Number === number)[0].Html : null}
                                init={{
                                    language_url: "/scripts/tinymce/langs/ru.js",
                                    language: 'ru',
                                    plugins: [
                                        'advlist', 'autolink', 'lists', 'link', 'charmap', 'preview',
                                        'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                        'insertdatetime', 'table', 'help', 'wordcount',
                                    ],
                                    toolbar: ' blocks ' +
                                        ' | bold italic underline| forecolor backcolor | alignleft aligncenter alignright' +
                                        ' | bullist numlist',
                                    content_style: 'body { font-family:Arial,Arial,sans-serif; font-size:14px }',
                                }}
                            />
                            {idObject === 2 && (
                                <div className="mt-15">
                                    <Form.Check // prettier-ignore
                                        type="switch"
                                        id="show_tracker_switch"
                                        label="Отображать в «Текущих задачах?»"
                                        defaultChecked={showTracker}
                                        onChange={(e) => showTrackerChange(e.target.checked)}
                                    />
                                </div>
                            )}
                            {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                            <div className='row mt-15'>
                                <div className='col-md-12 text-center'>
                                    <SrvButton typeBtn='save' size='lg' onClick={Update} loading={loading} />
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>
                )
            }
        </div>
    )
}

export default WidgetItemTextHtml;